import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react'
import { collection, doc, getDocs, getDoc, addDoc, updateDoc, deleteDoc } from "firebase/firestore";
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";
import db from '../firebase_config.js'

const auth = getAuth();

// Define our single API slice object
export const apiSlice = createApi({
  // The cache reducer expects to be added at `state.api` (already default - this is optional)
  reducerPath: 'api',
  baseQuery: fakeBaseQuery(),
  tagTypes: ['Problems'],
  endpoints: (build) => ({
  	signIn: build.query({
  		async queryFn(args) {

  			let email, password;

  			email = args ? args.email : email;
  			password = args? args.password : password;

        try {
			    const user = await signInWithEmailAndPassword(auth, email, password)
			      .then((userCredential) => {
			        const user = userCredential.user;
			        return { data: {
			        	email: user.email,
			        	uid: user.uid
			        	}
			        };
			      })

			  	return user

			  } catch(e) {
			    console.error("Error authenticating user with Firebase with email and password: ", e);
			    return { error: "Sign in failed: " + e.code}
			  }
      },
      providesTags: [{ type: 'User', id: 'USER'}]
  	}),
  	signOut: build.mutation({
  		async queryFn(arg) {
  			try {
  				const response = await signOut(auth).then(() => {
  					console.log("sucessfully signed out")
  				})
  			} catch(e) {
  				console.error("Error signing user out with Firebase: ", e);
  			}
  		},
  		invalidatesTags: [{ type: 'User', id: 'USER'}],
  	}),
  	getMarkets: build.query({
      async queryFn(arg) {
        try {
			    const response = await getDocs(collection(db, 'markets'))
			      .then((querySnapshot) => {
			        const docs = querySnapshot.docs
			          .map((doc) => ({ ...doc.data(), id:doc.id, }));
			        
			        console.log("Markets retrieved from Firestore.");
			        return { data: docs }
			      })
			  	
			  	return response

			  } catch(e) {
			    console.error("Error fetching markets from Cloud Firestore: ", e);
			  }
      },
      providesTags: [{ type: 'Markets', id: 'LIST'}],
    }),
    addMarket: build.mutation({
    	async queryFn(market) {
        try {
			    const response = await addDoc(collection(db, 'markets'), market)
			    	.then(doc => {
			    		console.log("Market written with ID: ", doc.id);
			    		return { data: {
			    				id: doc.id,
			    				name: doc.name
			    			}
			    		}
			    	})

			  	return response

			  } catch (e) {
			    console.error("Error adding market: ", e);
			  }
      },
      invalidatesTags: [{ type: 'Markets', id: 'LIST'}],
    }),
    updateMarket: build.mutation({
      async queryFn(market) {
        try {
			    const reference = doc(db, 'markets', market.id);
			    const response = await updateDoc(reference, market)
			    	.then(doc => {
			    		console.log("Updated market with ID: ", doc);
			    		return { data: doc }
			    	})

			  	return response

			  } catch (e) {
			    console.error("Error updating market: ", e);
			  }
      },
      invalidatesTags: [{ type: 'Markets', id: 'LIST'}],
   	}),
    deleteMarket: build.mutation({
    	async queryFn(id) {
        try {
			    const reference = doc(db, 'markets', id);
			    const response = await deleteDoc(reference)
			    	.then(() => {
			    		console.log("Deleted market with ID: ", id);
			    		return { data: id}
			    	})

			   	return response

			  } catch (e) {
			    console.error("Error deleting market: ", e);
			  }
      },
      invalidatesTags: [{ type: 'Markets', id: 'LIST'}],
    }),
    getAudiences: build.query({
      async queryFn(arg) {
        try {
			    const response = await getDocs(collection(db, 'audiences'))
			      .then((querySnapshot) => {
			        const docs = querySnapshot.docs
			          .map((doc) => ({ ...doc.data(), id:doc.id, }));
			        
			        console.log("Audiences retrieved from Firestore.");
			        return { data: docs }
			      })
			  	
			  	return response

			  } catch(e) {
			    console.error("Error fetching audiences from Cloud Firestore: ", e);
			  }
      },
      providesTags: [{ type: 'Audiences', id: 'LIST'}],
    }),
    addAudience: build.mutation({
    	async queryFn(audience) {
        try {
			    const response = await addDoc(collection(db, 'audiences'), audience)
			    	.then(doc => {
			    		console.log("Audience written with ID: ", doc.id);
			    		return { data: {
			    				id: doc.id,
			    				name: doc.name
			    			}
			    		}
			    	})

			  	return response

			  } catch (e) {
			    console.error("Error adding audience: ", e);
			  }
      },
      invalidatesTags: [{ type: 'Audiences', id: 'LIST'}],
    }),
    updateAudience: build.mutation({
      async queryFn(audience) {
        try {
			    const reference = doc(db, 'audiences', audience.id);
			    const response = await updateDoc(reference, audience)
			    	.then(doc => {
			    		console.log("Updated audience with ID: ", doc);
			    		return { data: doc }
			    	})

			  	return response

			  } catch (e) {
			    console.error("Error updating audience: ", e);
			  }
      },
      invalidatesTags: [{ type: 'Audiences', id: 'LIST'}],
   	}),
    deleteAudience: build.mutation({
    	async queryFn(id) {
        try {
			    const reference = doc(db, 'audiences', id);
			    const response = await deleteDoc(reference)
			    	.then(() => {
			    		console.log("Deleted audience with ID: ", id);
			    		return { data: id}
			    	})

			   	return response

			  } catch (e) {
			    console.error("Error deleting audience: ", e);
			  }
      },
      invalidatesTags: [{ type: 'Audiences', id: 'LIST'}],
    }),
  	getProblemSpaces: build.query({
      async queryFn(arg) {
        try {
			    const response = await getDocs(collection(db, 'problem-spaces'))
			      .then((querySnapshot) => {
			        const docs = querySnapshot.docs
			          .map((doc) => ({ ...doc.data(), id:doc.id, }));
			        
			        console.log("Problem Spaces retrieved from Firestore.");
			        return { data: docs }
			      })
			  	
			  	return response

			  } catch(e) {
			    console.error("Error fetching Problem Spaces from Cloud Firestore: ", e);
			  }
      },
      providesTags: [{ type: 'Problem Spaces', id: 'LIST'}],
    }),
    addProblemSpace: build.mutation({
    	async queryFn(problemSpace) {
        try {
			    const response = await addDoc(collection(db, 'problem-spaces'), problemSpace)
			    	.then(doc => {
			    		console.log("Problem Space written with ID: ", doc.id);
			    		return { data: {
			    				id: doc.id,
			    				name: doc.name
			    			}
			    		}
			    	})

			  	return response

			  } catch (e) {
			    console.error("Error adding prototype: ", e);
			  }
      },
      invalidatesTags: [{ type: 'Problem Spaces', id: 'LIST'}],
    }),
    updateProblemSpace: build.mutation({
      async queryFn(problemSpace) {
        try {
			    const reference = doc(db, 'problem-spaces', problemSpace.id);
			    const response = await updateDoc(reference, problemSpace)
			    	.then(doc => {
			    		console.log("Updated Problem Space with ID: ", doc);
			    		return { data: doc }
			    	})

			  	return response

			  } catch (e) {
			    console.error("Error updating Problem Space: ", e);
			  }
      },
      invalidatesTags: [{ type: 'Problem Spaces', id: 'LIST'}],
   	}),
    deleteProblemSpace: build.mutation({
    	async queryFn(id) {
        try {
			    const reference = doc(db, 'problem-spaces', id);
			    const response = await deleteDoc(reference)
			    	.then(() => {
			    		console.log("Deleted Problem Space with ID: ", id);
			    		return { data: id}
			    	})

			   	return response

			  } catch (e) {
			    console.error("Error deleting Problem Space: ", e);
			  }
      },
      invalidatesTags: [{ type: 'Problem Spaces', id: 'LIST'}],
    }),
    getProblems: build.query({
      async queryFn(arg) {
        try {
			    const response = await getDocs(collection(db, 'problems'))
			      .then((querySnapshot) => {
			        const docs = querySnapshot.docs
			          .map((doc) => ({ ...doc.data(), id:doc.id }));
			        
			        console.log("Problems retrieved from Firestore.");
			        return { data: docs }
			      })
			  	
			  	console.log(response)
			  	return response

			  } catch(e) {
			    console.error("Error fetching problems from Cloud Firestore: ", e);
			  }
      },
      providesTags: [{ type: 'Problems', id: 'LIST'}],
    }),
    addProblem: build.mutation({
    	async queryFn(problem) {
        try {
			    const response = await addDoc(collection(db, 'problems'), problem)
			    	.then(doc => {
			    		console.log("Document written with ID: ", doc.id);
			    		return { data: {
			    				id: doc.id,
			    				title: doc.title
			    			}
			    		}
			    	})

			  	return response

			  } catch (e) {
			    console.error("Error adding document: ", e);
			  }
      },
      invalidatesTags: [{ type: 'Problems', id: 'LIST'}],
    }),
    updateProblem: build.mutation({
      async queryFn(problem) {
        try {
			    const reference = doc(db, 'problems', problem.id);
			    const response = await updateDoc(reference, problem)
			    	.then(doc => {
			    		console.log("Updated document with ID: ", doc);
			    		return { data: doc }
			    	})

			  	return response

			  } catch (e) {
			    console.error("Error updating document: ", e);
			  }
      },
      invalidatesTags: [{ type: 'Problems', id: 'LIST'}],
      // Pick out data and prevent nested properties in a hook or selector
      // transformResponse: (response: { data: Post }, meta, arg) => response.data,
      // // Pick out errors and prevent nested properties in a hook or selector
      // transformErrorResponse: (
      //   response: { status: string | number },
      //   meta,
      //   arg
      // ) => response.status,
      // onQueryStarted is useful for optimistic updates
      // The 2nd parameter is the destructured `MutationLifecycleApi`
      // async onQueryStarted(
      //   arg,
      //   { dispatch, getState, queryFulfilled, requestId, extra, getCacheEntry }
      // ) {},
      // // The 2nd parameter is the destructured `MutationCacheLifecycleApi`
      // async onCacheEntryAdded(
      //   arg,
      //   {
      //     dispatch,
      //     getState,
      //     extra,
      //     requestId,
      //     cacheEntryRemoved,
      //     cacheDataLoaded,
      //     getCacheEntry,
      //   }
      // ) {},
    }),
    deleteProblem: build.mutation({
    	async queryFn(id) {
        try {
			    const reference = doc(db, 'problems', id);
			    const response = await deleteDoc(reference)
			    	.then(() => {
			    		console.log("Deleted document with ID: ", id);
			    		return { data: id}
			    	})

			   	return response

			  } catch (e) {
			    console.error("Error deleting document: ", e);
			  }
      },
      invalidatesTags: [{ type: 'Problems', id: 'LIST'}],
    }),
    getPrototypes: build.query({
      async queryFn(arg) {
        try {
			    const response = await getDocs(collection(db, 'prototypes'))
			      .then((querySnapshot) => {
			        const docs = querySnapshot.docs
			          .map((doc) => ({ ...doc.data(), id:doc.id, }));
			        
			        console.log("Prototypes retrieved from Firestore.");
			        return { data: docs }
			      })
			  	
			  	return response

			  } catch(e) {
			    console.error("Error fetching prototypes from Cloud Firestore: ", e);
			  }
      },
      providesTags: [{ type: 'Prototypes', id: 'LIST'}],
    }),
    addPrototype: build.mutation({
    	async queryFn(prototype) {
        try {
			    const response = await addDoc(collection(db, 'prototypes'), prototype)
			    	.then(doc => {
			    		console.log("Prototype written with ID: ", doc.id);
			    		return { data: {
			    				id: doc.id,
			    				name: doc.name
			    			}
			    		}
			    	})

			  	return response

			  } catch (e) {
			    console.error("Error adding prototype: ", e);
			  }
      },
      invalidatesTags: [{ type: 'Prototypes', id: 'LIST'}],
    }),
    updatePrototype: build.mutation({
      async queryFn(prototype) {
        try {
			    const reference = doc(db, 'prototypes', prototype.id);
			    const response = await updateDoc(reference, prototype)
			    	.then(doc => {
			    		console.log("Updated prototype with ID: ", doc);
			    		return { data: doc }
			    	})

			  	return response

			  } catch (e) {
			    console.error("Error updating prototype: ", e);
			  }
      },
      invalidatesTags: [{ type: 'Prototypes', id: 'LIST'}],
   	}),
    deletePrototype: build.mutation({
    	async queryFn(id) {
        try {
			    const reference = doc(db, 'prototypes', id);
			    const response = await deleteDoc(reference)
			    	.then(() => {
			    		console.log("Deleted prototype with ID: ", id);
			    		return { data: id}
			    	})

			   	return response

			  } catch (e) {
			    console.error("Error deleting prototype: ", e);
			  }
      },
      invalidatesTags: [{ type: 'Prototypes', id: 'LIST'}],
    })
  })
})

// Export the auto-generated hook for the `getProblems` query endpoint
export const { 
	useSignInQuery, useLazySignInQuery, useSignOutMutation,
	useGetMarketsQuery, useGetProblemSpacesQuery, useGetProblemsQuery, useGetAudiencesQuery, useGetPrototypesQuery,
	useAddMarketMutation, useAddProblemSpaceMutation, useAddProblemMutation, useAddAudienceMutation, useAddPrototypeMutation,
	useUpdateMarketMutation, useUpdateAudienceMutation, useUpdateProblemSpaceMutation, useUpdateProblemMutation, useUpdatePrototypeMutation,
	useDeleteMarketMutation, useDeleteAudienceMutation, useDeleteProblemSpaceMutation, useDeleteProblemMutation, useDeletePrototypeMutation
} = apiSlice






